// import React, { useMemo } from "react";
// import ReactECharts from "echarts-for-react";
// import { filterDataByDate } from "../../common/Constants";
// import useCommonStore from "../../store/CommonStore";

// interface UserRegistrationProps {
//   data: any;
// }

// const UserRegistrationChart: React.FC<UserRegistrationProps> = ({ data }) => {
//   const { selectedValue } = useCommonStore();

//   const filteredData = useMemo(() => {
//     return filterDataByDate(data, selectedValue);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [data, selectedValue]);

//   console.log("filteredData", filteredData);

//   const option = {
//     title: {
//       text: "User Registration Trends",
//       left: "right",
//       textStyle: {
//         fontSize: 16,
//         fontWeight: "bold",
//       },
//     },
//     tooltip: {
//       trigger: "axis",
//       axisPointer: {
//         type: "line",
//       },
//     },
//     legend: {
//       data: ["User Registration Trend"],
//       left: "left",
//     },
//     xAxis: {
//       type: "category",
//       data: [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ],
//     },
//     yAxis: {
//       type: "value",
//       name: "Registrations",
//     },
//     series: [
//       {
//         name: "User Registration Trend",
//         type: "line",
//         data: [
//           1800, 1900, 3000, 1500, 3200, 4200, 5000, 7000, 6200, 8100, 7300,
//           7600,
//         ],
//         smooth: true,
//         areaStyle: {
//           opacity: 0.2,
//         },
//         lineStyle: {
//           color: "#2563eb", // Blue color
//         },
//         itemStyle: {
//           color: "#2563eb",
//         },
//       },
//     ],
//     grid: {
//       left: "3%",
//       right: "4%",
//       bottom: "3%",
//       containLabel: true,
//     },
//   };

//   return (
//     <div className="w-full max-w-3xl mx-auto bg-white p-4 rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
//       <ReactECharts
//         option={option}
//         style={{ height: "300px", width: "100%" }}
//       />
//     </div>
//   );
// };

// export default UserRegistrationChart;

import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import useCommonStore from "../../../store/CommonStore";
import {
  filterDataByDate,
  generateXAxisLabels,
} from "../../../common/Constants";

interface UserRegistrationProps {
  data: any;
}

const UserRegistrationChart: React.FC<UserRegistrationProps> = ({ data }) => {
  const { selectedValue } = useCommonStore();

  const xAxisLabels = useMemo(
    () => generateXAxisLabels(selectedValue),
    [selectedValue]
  );

  const { filteredData } = useMemo(() => {
    return filterDataByDate(data, selectedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, selectedValue]);

  const chartData = useMemo(() => {
    if (!filteredData || filteredData.length === 0)
      return new Array(xAxisLabels.length).fill(0);

    const counts = new Array(xAxisLabels.length).fill(0);

    filteredData.forEach((item) => {
      const dateField = item?.created_at ?? null;
      if (!dateField) return;

      const dateObj = new Date(dateField);
      if (isNaN(dateObj.getTime())) return;

      const today = new Date();
      const diffInDays = Math.floor(
        (today.getTime() - dateObj.getTime()) / (1000 * 60 * 60 * 24)
      );

      const index = xAxisLabels.length - 1 - diffInDays;

      if (index >= 0 && index < xAxisLabels.length) {
        counts[index] += 1;
      }
    });

    return counts;
  }, [filteredData, xAxisLabels]);

  const option = {
    title: {
      text: "User Registration Trends",
      left: "center",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "line",
      },
    },
    legend: {
      data: ["User Registrations"],
      left: "left",
    },
    xAxis: {
      type: "category",
      // data: months,
      data: xAxisLabels,
    },
    yAxis: {
      type: "value",
      name: "Registrations",
    },
    series: [
      {
        name: "User Registrations",
        type: "line",
        data: chartData,
        smooth: true,
        areaStyle: {
          opacity: 0.2,
        },
        lineStyle: {
          color: "#2563eb",
        },
        itemStyle: {
          color: "#2563eb",
        },
      },
    ],
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
  };

  return (
    <div className="w-full max-w-3xl mx-auto bg-white p-4 rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
      <ReactECharts
        option={option}
        style={{ height: "300px", width: "100%" }}
      />
    </div>
  );
};

export default UserRegistrationChart;
